<template>
  <div>
    <div class="card">
      <div class="card-header">
        <i class="fa fa-align-justify"></i>
        Lista klientów do zatwierdzenia
      </div>
      <div class="card-actions">
        <a href class="btn btn-secondary btn-sm" @click.prevent="toggleFiltersVisibility()">
          <span v-if="filtersVisible">Ukryj filtry</span>
          <span v-if="!filtersVisible">Pokaż filtry</span>
        </a>
      </div>
      <div class="card-filters" v-if="filtersVisible">
        <form @submit.prevent="searchList()">
          <div class="row">
            <div class="form-group col-md-2">
              <label>Nazwisko</label>
              <input class="form-control" v-model="filters.qLastName" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Imiona</label>
              <input class="form-control" v-model="filters.qFirstName" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Pesel</label>
              <input class="form-control" v-model="filters.qPesel" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Miasto</label>
              <input class="form-control" v-model="filters.qCity" type="text"/>
            </div>
            <!--<div class="form-group col-md-2">-->
            <!--<label>Ulica</label>-->
            <!--<input class="form-control" v-model="filters.qStreet" type="text"/>-->
            <!--</div>-->
            <!--<div class="form-group col-md-2">-->
            <!--<label>Karta do wydania</label>-->
            <!--<select class="form-control" id="cardType" v-model="filters.qApplicableLoyaltyCard">-->
            <!--<option value=""></option>-->
            <!--<option value="yes">Tak</option>-->
            <!--<option value="no">Nie</option>-->
            <!--</select>-->
            <!--</div>-->
            <!--<div class="form-group col-md-2">-->
            <!--<label for="qZgodaNpdo">Zgoda NPDO</label>-->
            <!--<select class="form-control" id="qZgodaNpdo" v-model="filters.qZgodaNpdo">-->
            <!--<option value=""></option>-->
            <!--<option value="1">TAK</option>-->
            <!--<option value="0">NIE</option>-->
            <!--</select>-->
            <!--</div>-->
            <!--<div class="form-group col-md-2">-->
            <!--<label for="qZgodaNprd">Zgoda na wyświetlanie danych i rachunków</label>-->
            <!--<select class="form-control" id="qZgodaNprd" v-model="filters.qZgodaNprd">-->
            <!--<option value=""></option>-->
            <!--<option value="1">TAK</option>-->
            <!--<option value="0">NIE</option>-->
            <!--</select>-->
            <!--</div>-->
            <!--<div class="form-group col-md-2">-->
            <!--<label for="qZgodaNoih">Zgoda marketingowa</label>-->
            <!--<select class="form-control" id="qZgodaNoih" v-model="filters.qZgodaNoih">-->
            <!--<option value=""></option>-->
            <!--<option value="1">TAK</option>-->
            <!--<option value="0">NIE</option>-->
            <!--</select>-->
            <!--</div>-->
            <!--<div class="form-group col-md-2">-->
            <!--<label for="qZgodaEmail">Zgoda Email</label>-->
            <!--<select class="form-control" id="qZgodaEmail" v-model="filters.qZgodaEmail">-->
            <!--<option value=""></option>-->
            <!--<option value="1">TAK</option>-->
            <!--<option value="0">NIE</option>-->
            <!--</select>-->
            <!--</div>-->
            <!--<div class="form-group col-md-2">-->
            <!--<label for="qStatus">Status</label>-->
            <!--<select class="form-control" id="qStatus" v-model="filters.qStatus">-->
            <!--<option value="active">Aktywny</option>-->
            <!--<option value="archived">Zarchiwizowany</option>-->
            <!--</select>-->
            <!--</div>-->
          </div>
          <div class="row">
            <div class="form-group col-12">
              <button type="submit" class="btn btn-primary">Szukaj</button>

              <button type="button" @click="clearFilters()" class="btn btn-link">Wyczyść filtry</button>
            </div>
          </div>
        </form>
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-bordered table-striped">
          <thead>
          <tr>
            <th scope="col" @click="setOrderBy('lastName')">{{ $t('clients.fullName') }}</th>
            <th scope="col" @click="setOrderBy('street')">{{ $t('clients.address') }}</th>
            <th scope="col" @click="setOrderBy('city')">{{ $t('clients.city') }}</th>
            <th scope="col">{{ $t('clients.pesel') }}</th>
            <th scope="col">{{ $t('clients.clientId')}}</th>
            <th scope="col">OSOBA_ID</th>
            <th scope="col">{{ $t('branchName') }}</th>
            <th scope="col">{{ $t('common.actions') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr class="loading" v-if="isLoading" v-bind:key="item"
              v-for="item in $store.state[paramsName].pageSize">
            <td v-bind:data-id="item"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr v-if="!totalCount && !isLoading">
            <td colspan="8">
              Brak rekordów spełniających podane kryteria.
              <!--Zmień lub <a href @click.prevent="clearFilters()">wyczyść filtry</a>.-->
            </td>
          </tr>
          <tr v-for="client in list" v-if="!isLoading" :key="`${client.osobaId}_${client.branchId}`" class="client-row">
            <td>{{ client.fullName }}</td>
            <td>{{ client.address }}</td>
            <td>{{ client.city }}</td>
            <td>{{ client.pesel }}</td>
            <td>{{ client.clientId}}</td>
            <td>{{ client.osobaId}}</td>
            <td>{{ client.branchName}}</td>
            <td>
              <a href @click.prevent="goToDetails(client)">Szczegóły</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <list-pager
          v-bind:params-name="paramsName"
          v-bind:total-count="totalCount"
          @reload="loadItems()">
      </list-pager>
    </div>
  </div>
</template>

<script>
  import osobaService from '@Service/osobaService';
  import { router } from '@Router';
  import { listMixin } from '../helpers';
  import listPager from '@Component/list-pager';

  export default {
    data: function () {
      return {
        paramsName: 'osobaManualParams',
        list: [],
        totalCount: 0,
        filters: {},
        isLoading: false,
        filtersVisible: false,
      };
    },
    mixins: [
      listMixin,
    ],
    components: {
      listPager,
    },
    methods: {
      goToDetails: (osoba) => {
        const { osobaId, branchId } = osoba;
        router.push({ name: 'manualPersonsDetails', params: { osobaId, branchId } });
      },
      loadItems: function () {
        this.isLoading = true;
        osobaService.getManualSyncList(this.$store.state[this.paramsName])
          .then(response => {
            this.totalCount = parseInt(response.headers.get('totalCount'), 10);
            this.list = response.data;
          })
          .finally(() => this.isLoading = false);
      },
      searchList: function () {
        this.$store.commit('setParams', {
          paramsName: this.paramsName,
          params: {
            ...this.filters,
            offset: 0,
          },
        });

        this.loadItems();
      },
      clearFilters: function () {
        this.filters = {
          qLastName: '',
          qFirstName: '',
          qPesel: '',
          qCity: '',
        };
        this.searchList();
      },
    },
    mounted: function () {
      this.filters = {
        qCity: this.$store.state[this.paramsName].qCity,
        qPesel: this.$store.state[this.paramsName].qPesel,
        qFirstName: this.$store.state[this.paramsName].qFirstName,
        qLastName: this.$store.state[this.paramsName].qLastName,
      };
      this.loadItems();
    },
  };
</script>
<style></style>